import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { toast } from "react-toastify";
import { get } from "lodash";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const dispatch = useDispatch();
  const [dynamicFieldsError, setDynamicFieldsError] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    businessName: "",
    contactNo: "",
    email: "",
    address: "",
    distributorName: "",
    termsAndConditions: "",
    subject: "",
  });
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [terms, setTerms] = useState("");
  const [priceList, setPriceList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [distributorsList, setDistributorsList] = useState([]);
  const [emergencyContactError, setEmergencyContactError] = useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  const [dynamicFields, setDynamicFields] = useState([
    { product: "", currency: "Rs", mrp: "", discountedPrice: "", qty: "" },
  ]);

  useEffect(() => {
    getProductList();
    getQuotationList();
    // console.log("le bahi com", props.comp === "add");
    // if (props.comp === "add") getTerms();
  }, [isEdit]);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getProductList = () => {
    utils
      .callAPI("get", `/Product/product-price`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProductList(res);
        } else {
          setProductList([]);
        }
      })
      .catch((err) => {
        setProductList([]);
      });
  };

  const getPriceList = (value, index) => {
    utils
      .callAPI("get", `/Product/coupon-value?product_id=${value}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          let price = res.regularPrice || "";

          const fields = [...dynamicFields];
          fields[index].mrp = price;
          setDynamicFields(fields);
        } else {
          const fields = [...dynamicFields];
          fields[index].mrp = "";
          setDynamicFields(fields);
        }
      })
      .catch((err) => {
        const fields = [...dynamicFields];
        fields[index].mrp = "";
        setDynamicFields(fields);
      });
  };

  const getTerms = (id) => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", id === "none" ? "" : id);

    utils
      .callAPI("post", `/sales/getQuotationTerms`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setFormData((prevFormData) => ({
            ...prevFormData,
            termsAndConditions: res.contents, // Assuming res is the terms string received from API
          }));
        } else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            termsAndConditions: "", // Set to default if res is undefined or empty
          }));
        }
      })
      .catch((err) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          termsAndConditions: "", // Set to default if API call fails or res is undefined
        }));
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    const isOnlyDigits = /^\d+$/.test(value);

    if (name === "firstName" || name === "lastName") {
      if (isOnlyDigits) {
        // Prevent setting the state if the value contains only digits
        return;
      }
    }

    if (name === "contactNo") {
      validatedValue = value.replace(/\D/g, "");

      setEmergencyContactError(validatedValue.length !== 10);
      // // Restrict input to 10 digits
      // if (validatedValue.length > 10) {
      //   validatedValue = validatedValue.slice(0, 10);
      // }
    }

    if (name === "distributorName") {
      if (value) {
        getTerms(value);
      } else {
        setFormData({
          ...formData,
          distributorName: "VURA BAU-CHEMIE LLP PRODUCTS",
        });
      }
    }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  const handleDynamicFieldChange = (index, event) => {
    const { name, value } = event.target;
    const numericRegex = /^\d*\.?\d*$/;

    const fields = [...dynamicFields];

    if (name === "qty") {
      // Extract numeric part from the input value
      const numericPart = parseFloat(value.replace(/[^\d.]/g, ""));
      const isValidQty = !isNaN(numericPart) && numericPart > 0;

      if (isValidQty || value === "") {
        fields[index][name] = value;
      }
    } else if (name === "product") {
      fields[index][name] = value;
      getPriceList(value, index);
    } else if (name === "mrp") {
      const numericValue = parseFloat(value);
      if ((numericValue >= 0 || value === "") && /^\d*\.?\d*$/.test(value)) {
        fields[index][name] = value;
      }
    } else {
      fields[index][name] = value;
    }
    setDynamicFields(fields);

    if (dynamicFields.length >= 1) {
      setDynamicFieldsError("");
    }
  };

  const handleAddField = () => {
    setDynamicFields([
      ...dynamicFields,
      { product: "", currency: "Rs", mrp: "", discountedPrice: "", qty: "" },
    ]);
    setDynamicFieldsError("");
  };

  const handleRemoveField = (index) => {
    if (dynamicFields.length === 1) {
      setDynamicFieldsError("At least one product must be present.");
      return;
    }
    setDynamicFieldsError("");
    const fields = dynamicFields.filter((_, i) => i !== index);
    setDynamicFields(fields);
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", props?.rowData?.id);
      }
      bodyFormData.append("userId", userProfile?.id);
      bodyFormData.append("firstName", formData.firstName);
      bodyFormData.append(
        "distributorId",
        formData.distributorName === "none" ? "" : formData.distributorName
      );
      // bodyFormData.append(
      //   "start_date",
      //   moment(formData.startDate).format("YYYY-MM-DD")
      // );
      // bodyFormData.append(
      //   "end_date",
      //   moment(formData.endDate).format("YYYY-MM-DD")
      // );
      bodyFormData.append("lastName", formData.lastName);
      bodyFormData.append("companyName", formData.businessName);
      bodyFormData.append("emailId", formData.email);
      bodyFormData.append("contactNo", formData.contactNo);
      bodyFormData.append("address", formData.address);
      bodyFormData.append("subject", "Test");
      bodyFormData.append("terms_condition", formData.termsAndConditions);
      dynamicFields.forEach((field, index) => {
        bodyFormData.append(`product_id[${index + 1}]`, field.product || "");
        bodyFormData.append(`currency[${index + 1}]`, field.currency || "");
        bodyFormData.append(`sales_price[${index + 1}]`, field.mrp || "");
        bodyFormData.append(
          `discount_price[${index + 1}]`,
          field.discountedPrice || "0"
        );
        bodyFormData.append(`qty[${index + 1}]`, field.qty || "0");
      });

      utils
        .callAPI(
          "post",
          `/sales/save
        `,
          bodyFormData
        )
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    console.log("Quation add ka prop data", props?.rowData);
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);
      //Here i want to update dynammic fields from prop

      if (props.rowData.products && props.rowData.products.length > 0) {
        setDynamicFields(
          props.rowData.products.map((product) => ({
            product: product.product_id,
            currency: product.currency,
            mrp: product.sales_price,
            discountedPrice: product.discount_price,
            qty: product.qty,
          }))
        );
      } else {
        setDynamicFields([
          { product: "", currency: "", mrp: "", discountedPrice: "", qty: "" },
        ]);
      }

      console.log("reaching here", props?.rowData);

      setFormData({
        firstName: props?.rowData?.firstName || "",
        lastName: props?.rowData?.lastName || "",
        businessName: props?.rowData?.companyName || "",
        contactNo: props?.rowData?.contactNo || "",
        email: props?.rowData?.emailId || "",
        address: props?.rowData?.address || "",
        termsAndConditions: props?.rowData?.terms_condition || "",
        subject: props?.rowData?.subject || "",
        distributorName:
          props?.rowData?.distributorId === "0"
            ? "none"
            : props?.rowData?.distributorId || "",
      });

      console.log("reaching here");
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const getQuotationList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("userId", userProfile?.employeeId);
    bodyFormData.append("id", "");
    bodyFormData.append("vendor_type", "Distributor");
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    // bodyFormData.append("cancelstatus", "0");
    utils
      .callAPI("post", `/sales/getsalesFormList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDistributorsList(res.result);

          // console.log(
          //   "Yeh hai company",
          //   res.result.map((company) => company.companyName)
          // );
        } else {
          setDistributorsList([]);
        }
      })
      .catch((err) => {
        setDistributorsList([]);
      });
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>{isEdit ? "Edit" : "Add"}</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Name of Distributor"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      name="distributorName"
                      value={formData.distributorName}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Distributor...</option>
                      {distributorsList?.map((distributor, index) => (
                        <option key={index} value={distributor.id}>
                          {distributor.companyName}
                        </option>
                      ))}

                      <option value="none">VURA BAU-CHEMIE LLP PRODUCTS</option>
                    </RB.Form.Select>
                    {/* {distributorErrors.distributorName && (
                      <span className="text-danger">
                        {distributor.distributorName}
                      </span>
                    )} */}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              {/* {formData.distributorName === "none" && (
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Distributor Name"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        value="VURA BAU-CHEMIE LLP PRODUCTS"
                        readOnly
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              )} */}
            </RB.Row>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="First Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter First Name"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Last Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Last Name"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Business Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Business Name"
                      name="businessName"
                      value={formData.businessName}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Email"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Contact No"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Number of Coupons"
                      name="contactNo"
                      value={formData.contactNo}
                      onChange={handleInputChange}
                      required
                      maxLength={10}
                    />
                    {emergencyContactError ? (
                      <span className="text-danger">
                        {" "}
                        Please provide a valid Contact Number.
                      </span>
                    ) : (
                      ""
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Address"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      type="text"
                      placeholder="Enter Address"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                      maxLength={100}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <RB.Form.Group
              as={RB.Row}
              className="mb-3"
              controlId="formHorizontalDynamicFields"
            >
              {dynamicFields.map((field, index) => (
                <RB.Row className="g-3">
                  <RB.Col className="col-md-3">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Product"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          as="select"
                          name="product"
                          value={field.product}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                          required
                        >
                          <option value="">Select Product...</option>
                          {productList.map((product) => (
                            <option key={product.id} value={product.id}>
                              {product.product_name}
                            </option>
                          ))}
                        </RB.Form.Control>
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  <RB.Col>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Currency"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Currency"
                          name="currency"
                          value={field.currency}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                  <RB.Col>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="MRP"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter MRP"
                          name="mrp"
                          value={field.mrp}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                  <RB.Col className="col-md-auto">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Discounted Price"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Discounted Price"
                          name="discountedPrice"
                          value={field.discountedPrice}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                  <RB.Col>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        label="Quantity"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Enter Quantity"
                          name="qty"
                          value={field.qty}
                          onChange={(e) => handleDynamicFieldChange(index, e)}
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                  {/* <RB.Col md={1} className="d-flex align-items-end mb-3">
                    {dynamicFields.length - 1 === index ? (
                      <RB.Button
                        variant="outline-dark"
                        onClick={handleAddField}
                      >
                        <AddCircleOutline />
                      </RB.Button>
                    ) : (
                      <RB.Button
                        variant="outline-danger"
                        onClick={() => handleRemoveField(index)}
                      >
                        <DeleteOutline />
                      </RB.Button>
                    )}
                  </RB.Col> */}

                  <RB.Col className="d-flex align-items-end mb-3 col-md-auto g-1">
                    <RB.Button
                      variant="outline-danger"
                      className="btn-sm me-2"
                      onClick={() => handleRemoveField(index)}
                    >
                      <DeleteOutline />
                    </RB.Button>
                    {dynamicFields.length - 1 === index && (
                      <RB.Button
                        variant="outline-dark"
                        className="btn-sm"
                        onClick={handleAddField}
                      >
                        <AddCircleOutline />
                      </RB.Button>
                    )}
                  </RB.Col>
                </RB.Row>
              ))}
              {dynamicFieldsError && (
                <RB.Row>
                  <RB.Col>
                    <span className="text-danger">{dynamicFieldsError}</span>
                  </RB.Col>
                </RB.Row>
              )}
            </RB.Form.Group>

            <h5>Terms and Conditions</h5>
            <RB.Row>
              <RB.Col md={12}>
                <div className="mb-3 mt-3">
                  <ReactQuill
                    theme="snow"
                    className="custom-quill"
                    value={formData.termsAndConditions}
                    onChange={(content) =>
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        termsAndConditions: content,
                      }))
                    }
                    placeholder="Enter Terms and Conditions"
                    required
                  />
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
